module.exports = __webpack_public_path__ + "c4803be3d50ca4dcb70b2a1d6089af.png";